module.exports = __webpack_public_path__ + "img/undraw_Working_re.540b2d2a.png";